import { render, staticRenderFns } from "./categories_bMenu.vue?vue&type=template&id=8a5ab9de&scoped=true"
import script from "./categories_bMenu.vue?vue&type=script&lang=js"
export * from "./categories_bMenu.vue?vue&type=script&lang=js"
import style0 from "./categories_bMenu.vue?vue&type=style&index=0&id=8a5ab9de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a5ab9de",
  null
  
)

export default component.exports